import { useMutation, useQueryClient } from "@tanstack/react-query"

import { createToast, Toasts } from "../../components/toast/Toast"
import { QUERY_KEYS } from "../../networking/queries"
import { saveProfileInfo } from "../../networking/user"
import { ToastType } from "../../types"

// TODO: needs optimistic updates
const useEditPersonalInfoMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: saveProfileInfo,
    onSuccess: () => {
      queryClient.refetchQueries([QUERY_KEYS.USER])
      queryClient.refetchQueries([QUERY_KEYS.PRACTICE])
      createToast({
        title: "Profile updated successfully",
        type: ToastType.SUCCESS,
      })
    },
    onError: () => createToast(Toasts.GENERAL_ERROR),
  })
}

export default useEditPersonalInfoMutation
